import React from "react";
import Icon from "../../../components/Icon";
import styles from "./TemplateCard.module.sass";

const Type = {
	LIMITED_EDITION: "LIMITED",
	OPEN_EDITION: "OPEN",
	SINGLE_EDITION: "SINGLE",
};

const TemplateCard = ({ item, removeTemplate, editOpen, marked, _key }) => {
	console.log(item);
	const image = item?.image !== "" ? item?.image : "";
	return (
		<div className={styles.card}>
			{marked.includes(_key) && (
				<div className={styles.banner}>Missing fields</div>
			)}
			<div className={styles.wrapper}>
				<img alt="" src={image} />
				<div className={styles.detail}>
					<div>Name</div>
					<div className={styles.col2}>{item.name}</div>
					<div>Count</div>
					<div className={styles.col2}>{item.totalNFTs}</div>
					<div>Type</div>
					<div className={styles.col2}>{Type[item.type]}</div>
					<div>Price</div>
					<div className={styles.col2}>$ {item.price}</div>
				</div>
				<div className={styles.control}>
					<div className={styles.btns}>
						<button onClick={editOpen} type="button" className="button-small">
							<Icon size="24" name="edit" />
						</button>
						<button
							type="button"
							onClick={removeTemplate}
							className="button-small button-red"
						>
							<Icon size="24" name="trash" />
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TemplateCard;
